import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import dayjs from "dayjs";
import "dayjs/locale/fi";
import "dayjs/locale/sv";
import "dayjs/locale/en";

import { Base } from "../framework/common/base";

import en from "./en.json";
import fi from "./fi-FI.json";
import sv from "./sv.json";

export const cultureCodeFinnish = "fi";
export const cultureCodeEnglish = "en-US";
export const cultureCodeSwedish = "sv";

export const defaultLanguage = cultureCodeFinnish;

export const defaultNamespace = "default";

export const resources = {
    "en": {
        [defaultNamespace]: en,
    },
    "en-US": {
        [defaultNamespace]: en,
    },
    "fi": {
        [defaultNamespace]: fi,
    },
    "sv": {
        [defaultNamespace]: sv,
    }
};

void i18n
    .use(initReactI18next)
    .use(LanguageDetector)
    .init({
        defaultNS: defaultNamespace,
        ns: [defaultNamespace],
        resources,
        fallbackLng: defaultLanguage,
        supportedLngs: [
            cultureCodeFinnish,
            cultureCodeEnglish,
            "en",
            cultureCodeSwedish
        ],
        nonExplicitSupportedLngs: true,
        debug: process.env.NODE_ENV !== "production",
        interpolation: {
            escapeValue: false,
        },
    });

export const getDayjsLocale = (culture: string): string => {
    switch (culture) {
        case cultureCodeSwedish:
            return "sv";
        case cultureCodeEnglish:
            return "en";
        case cultureCodeFinnish:
        default:
            return "fi";
    }
};

export const getLocalizedWeekDayName = (date: Date | string, culture: string): string => {
    const dayjsLocale = getDayjsLocale(culture);
    return Base.capitalizeFirstChar(
        dayjs(date).locale(dayjsLocale).format("dddd")
    );
};

export default i18n;